import {
  Building2,
  Target,
  Eye,
  Award,
  Users,
  Factory,
  Leaf,
  ShieldCheck,
  Truck,
  Star,
  Heart,
  Sparkles,
  FlaskConical,
  Globe,
  Clock,
  Handshake,
  Trophy,
  Lightbulb,
  BadgeCheck,
  Package,
  FileText,
} from "lucide-react";

/**
 * Pure helpers that the PUBLIC storefront also needs. They live here (not in CatalogStudioSectionEditors.jsx)
 * so the heavy Studio editor module can be lazy-loaded and stay out of the main bundle.
 */

export const INFO_CARD_ICONS = {
  building: { Icon: Building2, label: "الشركة" },
  target: { Icon: Target, label: "هدف" },
  eye: { Icon: Eye, label: "رؤية" },
  award: { Icon: Award, label: "جودة / جائزة" },
  users: { Icon: Users, label: "فريق / عملاء" },
  factory: { Icon: Factory, label: "مصنع" },
  leaf: { Icon: Leaf, label: "طبيعي / بيئة" },
  shield: { Icon: ShieldCheck, label: "أمان / ضمان" },
  truck: { Icon: Truck, label: "توصيل" },
  star: { Icon: Star, label: "نجمة" },
  heart: { Icon: Heart, label: "قلب" },
  sparkles: { Icon: Sparkles, label: "نظافة / لمعان" },
  flask: { Icon: FlaskConical, label: "مختبر / كيماويات" },
  globe: { Icon: Globe, label: "عالمي" },
  clock: { Icon: Clock, label: "خبرة / وقت" },
  handshake: { Icon: Handshake, label: "شراكة" },
  trophy: { Icon: Trophy, label: "إنجاز" },
  lightbulb: { Icon: Lightbulb, label: "ابتكار" },
  badge: { Icon: BadgeCheck, label: "معتمد" },
  package: { Icon: Package, label: "منتجات" },
  file: { Icon: FileText, label: "ملف" },
};

export function hasDedicatedStudioPanel(type, variant) {
  const t = String(type || "");
  const v = String(variant || "").toLowerCase();
  if (t === "info_cards") return true;
  if (t === "features_grid" && ["stats", "deals_row", "category_circles", "categories", "trust"].includes(v)) return true;
  if (t === "text" && v === "faq") return true;
  if (t === "image_banner" && ["promo", "countdown"].includes(v)) return true;
  if (t === "text_image_split" && v === "about_cards") return true;
  if (t === "carousel") return true;
  if (t === "featured_products" || t === "products_carousel") return true;
  return false;
}

/** ارتفاع شريحة السلايدر (بكسل) حسب إعداد طول السكشن */
export function carouselSlideHeightPx(sectionHeightKey, variant = "") {
  const v = String(variant || "").toLowerCase();
  const isBrands = v === "brands" || v === "instagram" || v === "logo_row";
  const key = String(sectionHeightKey || "md").toLowerCase();
  if (isBrands) {
    if (key === "sm") return 200;
    if (key === "lg") return 320;
    if (key === "xl") return 400;
    if (key === "2xl") return 480;
    return 260;
  }
  if (key === "sm") return 280;
  if (key === "lg") return 520;
  if (key === "xl") return 640;
  if (key === "2xl") return 720;
  return 400;
}

export function isProImageBannerVariant(variant) {
  return ["promo", "countdown"].includes(String(variant || "").toLowerCase());
}
